import { useState, useEffect, useCallback } from 'react'
import { useStatisticCases } from './useStatisticCases'

export const useCases = () => {
  const [casesToShow, setCasesToShow] = useState([])
  const [allCases, setAllCases] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [cases, setCases] = useState([])
  const [casesPerPage, setCasesPerPage] = useState(10)
  const { statistics, getStatistics } = useStatisticCases()

  const calculateListOfPages = useCallback(() => {
    const totalCases = Array.isArray(cases) ? cases.length : 0
    const pages = []
    const numberOfPages = Math.ceil(totalCases / casesPerPage)
    for (let i = 1; i <= numberOfPages; i++) {
      pages.push(i)
    }
    if (pages[pages.length - 1] < currentPage) {
      setCurrentPage(pages[pages.length - 1])
    }
    return pages
  }, [cases, casesPerPage, currentPage])

  const resetDataset = useCallback((newCases) => {
    const dataset = Array.isArray(newCases) ? newCases : []
    setAllCases(dataset)
    setCases(dataset)
  }, [])

  const search = useCallback((filters) => {
    const { status, search: searchVal, period } = filters

    const setStatusFilter = (statusVal) => {
      if (!Array.isArray(allCases)) {
        return []
      }
      if (statusVal === 'all') {
        return allCases
      } else {
        const filteredCases = allCases.filter(singleCase => {
          return singleCase.estado === statusVal
        })
        return filteredCases
      }
    }

    const setMonthFilter = (periodVal) => {
      if (!Array.isArray(allCases)) {
        return []
      }
      const parsedPeriod = Number(periodVal)
      const filteredCases = allCases.filter(singleCase => {
        const date = new Date(singleCase.fecha)
        const actualDate = new Date()
        const month = (actualDate.getFullYear() - date.getFullYear()) * 12 + (actualDate.getMonth() - date.getMonth())
        return month <= parsedPeriod
      })
      return filteredCases
    }

    const searchCasesHandler = (value) => {
      if (!Array.isArray(allCases)) {
        return []
      }
      if (value === '') {
        return allCases
      } else {
        const filteredCases = allCases.filter(singleCase => {
          const patientName = `${singleCase.paciente.nombre} ${singleCase.paciente.apellido}`
          const dni = `${singleCase.paciente.dni}`
          return patientName.toLowerCase().includes(value.toLowerCase()) || dni.includes(value)
        })
        return filteredCases
      }
    }

    const casesFilteredByStatus = setStatusFilter(status)
    const casesFilteredBySearch = searchCasesHandler(searchVal)
    const casesFilteredByPeriod = setMonthFilter(period)
    const casesFiltered = casesFilteredByStatus.filter(singleCase => {
      return casesFilteredBySearch.includes(singleCase)
    }).filter(singleCase => {
      return casesFilteredByPeriod.includes(singleCase)
    })
    setCases(casesFiltered)
  }, [allCases])

  const casesToShowHandler = (cases, currentPage, casesPerPage) => {
    if (!Array.isArray(cases)) {
      setCasesToShow([])
      return
    }
    const sortedCases = [...cases].sort((a, b) => {
      if (a.fecha > b.fecha) return -1
      if (a.fecha < b.fecha) return 1
      return 0
    })
    const indexOfLastCase = currentPage * casesPerPage
    const indexOfFirstCase = indexOfLastCase - casesPerPage
    const currentCases = sortedCases.slice(indexOfFirstCase, indexOfLastCase)
    setCasesToShow(currentCases)
  }

  useEffect(() => {
    if (Array.isArray(cases)) {
      if (allCases.length === 0) {
        setAllCases(cases)
      }
      casesToShowHandler(cases, currentPage, casesPerPage)
    } else {
      setCasesToShow([])
    }
  }, [cases, currentPage, casesPerPage])

  useEffect(() => {
    getStatistics(allCases)
  }, [allCases])

  return {
    calculateListOfPages,
    setCurrentPage,
    setCasesPerPage,
    setCases,
    resetDataset,
    search,
    statistics,
    currentPage,
    casesToShow,
    cases,
    casesPerPage
  }
}
